// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__1kC3D","Layout__Main":"Layout_Layout__Main__2VIKn"};